export const startTofScanRendering = (
  active: boolean,
  render: () => void,
  requestFrame: (callback: FrameRequestCallback) => number = (callback) => requestAnimationFrame(callback),
  cancelFrame: (handle: number) => void = (handle) => cancelAnimationFrame(handle),
) => {
  render();
  if (!active) return undefined;

  let animationFrame = 0;
  const renderScan = () => {
    render();
    animationFrame = requestFrame(renderScan);
  };
  animationFrame = requestFrame(renderScan);
  return () => cancelFrame(animationFrame);
};